import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/view/Index'
import Survey from "../components/view/Survey";
import News from "../components/view/News";
import Laws from "../components/view/Laws";
import Admissionnotice from "../components/view/Admissionnotice";
import Publicityedu from "../components/view/Publicityedu";
import Technocracy from "../components/view/Technocracy";
import Contactus from "../components/view/Contactus";
import Login from "../components/view/Login";
import Register from "../components/view/Register";
import Newsparticulars from "../components/view/Newsparticulars";
Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/Survey',
      name: 'Survey',
      component: Survey
    },
    {
      path: '/News',
      name: 'News',
      component: News
    },
    {
      path: '/Laws',
      name: 'Laws',
      component: Laws
    },
    {
      path: '/Admissionnotice',
      name: 'Admissionnotice',
      component: Admissionnotice
    },
    {
      path: '/Publicityedu',
      name: 'Publicityedu',
      component: Publicityedu
    },
    {
      path: '/Technocracy',
      name: 'Technocracy',
      component: Technocracy
    },
    {
      path: '/Contactus',
      name: 'Contactus',
      component: Contactus
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/Newsparticulars',
      name: 'Newsparticulars',
      component: Newsparticulars
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js